export default __webpack_public_path__ + "static/media/CN.8e3228bd.svg";